import http from "../http";

import TokenService from "./token.service";

const AuthService = {
    // ????????
    // hasPermission: (permission) => {
    //     const user = JSON.parse(localStorage.getItem("user"));
    //     // console.log(user, user.permissions);
    //     //permission localstorage da tutulmayacak. kesinlikle !!! bunun için ayrı modüle ve service yazılacak. ondan sonra
    //     return user.permissions && user.permissions.includes(permission)
    // },

    login: async (email, password) => {
        const response = await http.instance.post("AU/auth", {email: email, password: password});
        TokenService.setToken(response.data.accessToken, response.data.refreshToken);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        http.setHeader();
        http.mountAuthInterceptor();

        return response.data.user;
    },

    refreshToken: async () => {
        const response = await http.instance.post("AU/auth/refresh", {refreshToken: TokenService.getRefreshToken()});
        TokenService.setToken(response.data.accessToken, response.data.refreshToken);
        localStorage.setItem("user", JSON.stringify(response.data.user));

        http.setHeader();

        return response.data.user;
    },

    logout: () => {
        TokenService.removeToken();
        localStorage.removeItem("user");

        http.clearHeader();
        http.unmountAuthInterceptor();
    }
};

export default AuthService
